import { formatCurrency } from '@if/core/utils'
import { Typography } from '@mui/material'
import { mustShowInterestRate } from '@src/data/creditapp-selectors'
import useFeatureFlags from '@src/hooks/config-hooks'
import { CreditApplication } from '@src/types/CreditApplicationSchema'
import { Merchant } from '@src/types/Merchant'
import { useTranslation } from 'react-i18next'

interface Props {
  creditApp: CreditApplication
  merchant: Merchant
  hasActivePaymentPlans?: boolean
}
const PrequalApproved = ({ creditApp, merchant, hasActivePaymentPlans }: Props) => {
  const { t } = useTranslation()
  const { flags } = useFeatureFlags()
  const mustDisplayInterests = mustShowInterestRate(creditApp, merchant, !!flags.UseMerchDBshowRate)

  const rateLabel = hasActivePaymentPlans
    ? `${t('viewCreditApplication.interestRate')} (${t('common.regular')})`
    : t('viewCreditApplication.interestRate')
  return (
    <>
      {mustDisplayInterests && creditApp.prequalificationDecision != null && (
        <div>
          <Typography variant="subtitle1">{rateLabel}</Typography>
          <Typography variant="body1">
            {`${creditApp.prequalificationDecision.minInterestRate} - ${creditApp.prequalificationDecision.maxInterestRate}%`}
          </Typography>
        </div>
      )}
      <div>
        <Typography variant="subtitle1">{t('viewCreditApplication.amountRequested')}</Typography>
        <Typography variant="body1">{formatCurrency(creditApp.requestedLoanAmount)}</Typography>
      </div>
      {creditApp.prequalificationDecision != null && creditApp.requestedLoanAmount && creditApp.prequalificationDecision.maxLoanAmount && (
      <div>
        <Typography variant="subtitle1">{t('worksheet.maxLoanAmount')}</Typography>
        <Typography variant="body1">{formatCurrency(Math.min(creditApp.requestedLoanAmount, creditApp.prequalificationDecision.maxLoanAmount))}</Typography>
      </div>
      )}
    </>
  )
}

export default PrequalApproved
